import SearchIcon from '@mui/icons-material/Search';
import {
  Button,
  Paper,
} from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React, { useContext } from 'react';

import { ProductTypeContext } from './ProductTypeContext';

function ProductTypeHeader({
  tabIndex,
}) {
  const {
    // name,
    // username,
    // setUsername,
    resetAllFilters,
    fetchData,
    fetchLogs,
    setSearchValue,
    searchValue,
    searchLable,
    setOpenCreate,
    productTypeCount,
  } = useContext(ProductTypeContext);
  // const [showPopup, setShowPopup] = useState(false);
  // const togglePopup = () => setShowPopup(!showPopup);
  return (
    <div className="flex flex-col justify-between mb-4 md:mb-8 md:flex-row md:items-center">
      <div>
        <Box sx={{ padding: '20px' }}>
          <Typography
            variant="h3"
            sx={{
              color: '#384451',
              marginBottom: 1,
            }}
          >
            Product Types
          </Typography>
          <Typography variant="body1" sx={{ marginBottom: 3 }}>
            Create and Manage Product Types
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box>
              <Box
                sx={{
                  marginBottom: 0,
                  width: '800px',
                }}
              >

                <Stack direction="row" gap={2}>
                  <TextField
                    variant="outlined"
                    id="search-field"
                    label={searchLable}
                    className="w-[250px]"
                    value={searchValue}
                    onChange={(event) => setSearchValue(event.target.value)}
                    InputProps={{
                      style: {
                        borderRadius: 30,
                        backgroundColor: '#E0F0F8',
                        height: '45px',
                      },
                    }}
                  />
                  {/* <Button
                    onClick={togglePopup}
                    className="text-main ml-4"
                  >
                    FILTERS
                  </Button> */}
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: 30,
                      width: 130,
                      height: '45px',
                      backgroundColor: '#384451',
                    }}
                    onClick={resetAllFilters}
                  >
                    Reset
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<SearchIcon />}
                    sx={{
                      borderRadius: 30,
                      width: 130,
                      height: '45px',
                      backgroundColor: '#384451',
                    }}
                    onClick={() => {
                      if (tabIndex === 0) {
                        fetchData();
                      }
                      if (tabIndex === 1) {
                        fetchLogs();
                      }
                    }}
                  >
                    Search
                  </Button>
                </Stack>
              </Box>
            </Box>
          </Box>
        </Box>
      </div>
      <Stack direction="column" gap={2} spacing={2}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 2,
          }}
        >

          <Paper
            elevation={1}
            sx={{
              borderRadius: '20px',
              padding: 1,
              textAlign: 'left',
              width: 150,
              border: '2px solid #5A9EA8',
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                color: '#5A9EA8',
                fontWeight: 'bold',
              }}
            >
              Product Types
            </Typography>
            <Typography variant="h4">
              <center>{productTypeCount}</center>
            </Typography>
          </Paper>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 2,
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant="contained"
            sx={{
              borderRadius: 30,
              width: 160,
              height: '45px',
              backgroundColor: '#384451',
            }}
            onClick={() => setOpenCreate(true)}
          >
            + Product Type
          </Button>
        </Box>
      </Stack>
    </div>
  );
}

export default ProductTypeHeader;
